import { FC } from 'react'

import UploadImageProvider from './context/Provider'
import Component from './Component'
import { UploadImageProviderProps, ImagesFromUploadImage } from './types'

type Props = UploadImageProviderProps & {
  images?: ImagesFromUploadImage[]
}

const UploadImage: FC<Props> = (props) => {
  return (
    <UploadImageProvider {...props}>
      <Component />
    </UploadImageProvider>
  )
}

export default UploadImage
